import { IApplicationState } from '../../types/redux';

export const selectCurrentQuestionsPage = (state: IApplicationState): number => {
  return state.questions.page;
};
